import { render, staticRenderFns } from "./teaser.vue?vue&type=template&id=22874d8b&scoped=true&"
import script from "./teaser.vue?vue&type=script&lang=js&"
export * from "./teaser.vue?vue&type=script&lang=js&"
import style0 from "./teaser.vue?vue&type=style&index=0&id=22874d8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22874d8b",
  null
  
)

export default component.exports